<template>
    <b-overlay :show="pdfLoading" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block">
        <b-button variant="custom-outline-secondary" class="fs-14 mt-2" @click="downloadPDF"> Скачать извещение </b-button>
    </b-overlay>
</template>

<script>
import FileDownload from 'js-file-download';

export default {
    name: 'fl44-unknown-volume-download-purchase-pdf-button',
    props: {
        purchaseId: {
            type: Number,
            required: true
        },
        regNumber: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            pdfLoading: false
        };
    },
    methods: {
        downloadPDF() {
            this.pdfLoading = true;
            this.$api.products.fl44UnknownVolume.purchases
                .downloadPurchasePdf(this.purchaseId)
                .then((response) => {
                    const fileName = `Извещение ${this.regNumber}.pdf`;
                    FileDownload(response.data, fileName);
                })
                .catch((error) => {
                    this.showError(error);
                })
                .finally(() => {
                    this.pdfLoading = false;
                });
        }
    }
};
</script>
